import { render, staticRenderFns } from "./PublishingScheduleItem.vue?vue&type=template&id=3396d4be&"
import script from "./PublishingScheduleItem.vue?vue&type=script&lang=js&"
export * from "./PublishingScheduleItem.vue?vue&type=script&lang=js&"
import style0 from "./PublishingScheduleItem.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItemAvatar,VListItemContent})
